import { Autocomplete, Grid, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import {
  InputCountry,
  LanguageAutocomplete,
  RoleAutocomplete,
  StatusAutocomplete,
  VisibilityAutocomplete
} from '../../../../../shared/components/inputs'
import { IStatus, IVisibility } from '@/contexts/backoffice/courses/models/course'
import { ISeminar } from '../../../models/Seminars'
import CustomTextField from '@/contexts/shared/components/inputs/CustomTextField'
import { useSelector } from 'react-redux'
import { IRootState } from '@/redux/types'

interface GeneralTabProps {
  VISIBILITY: IVisibility[]
  STATUS: IStatus[]
  seminarState: ISeminar
  handleInputChange: (inputName: string, value: any) => void
}

export const GeneralTab = ({ VISIBILITY, STATUS, seminarState, handleInputChange }: GeneralTabProps) => {
  const { t } = useTranslation(['global'])

  const { seminartypes } = useSelector((state: IRootState) => state.seminartype)
  const { msgForm, errorForm } = useSelector((state: IRootState) => state.validator)
  const { description, seminartype, countries, language, status, visibility, role } = seminarState

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={8}>
        <CustomTextField inputName="description" value={description} handleInputChange={handleInputChange} required />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          id="combo-box-seminarytypes"
          disableClearable
          value={seminartype}
          options={seminartypes}
          onChange={(_event, value) => {
            handleInputChange('seminartype', value)
          }}
          getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
          renderInput={params => (
            <TextField
              {...params}
              error={errorForm.type}
              helperText={msgForm.type}
              required
              label={t('category')}
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <InputCountry value={countries} handleInputChange={handleInputChange} />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <LanguageAutocomplete value={language} handleInputChange={handleInputChange} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <StatusAutocomplete value={status} handleInputChange={handleInputChange} options={STATUS} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <VisibilityAutocomplete value={visibility} handleInputChange={handleInputChange} options={VISIBILITY} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <RoleAutocomplete value={role} handleInputChange={handleInputChange} />
      </Grid>
    </Grid>
  )
}
